import { useEffect, useState } from "react";
import { useApp } from "@/lib/AppContext";

export default function WelcomeToast({ isNewCustomer, onDone }) {
  const { lang } = useApp();
  const isAr = lang === "ar";
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false);
      setTimeout(onDone, 400);
    }, 3000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      className={`fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm transition-opacity duration-400 ${visible ? "opacity-100" : "opacity-0"}`}
      dir={isAr ? "rtl" : "ltr"}
    >
      <div className={`bg-white dark:bg-gray-900 rounded-3xl shadow-2xl px-8 py-10 max-w-sm w-full mx-4 text-center transform transition-all duration-400 ${visible ? "scale-100" : "scale-90"}`}>
        {isNewCustomer ? (
          <>
            <div className="text-6xl mb-4">🎉</div>
            <h2 className="text-2xl font-black text-primary mb-2">
              {isAr ? "أهلاً وسهلاً بك!" : "Welcome Aboard!"}
            </h2>
            <p className="text-muted-foreground text-sm leading-relaxed">
              {isAr
                ? "يسعدنا انضمامك لعائلة مغاسل القمر الأبيض\nاستعد للف العجلة والفوز بجائزة مميزة! 🌙"
                : "We're glad you joined White Moon Laundry!\nGet ready to spin and win! 🌙"}
            </p>
          </>
        ) : (
          <>
            <div className="text-6xl mb-4">👋</div>
            <h2 className="text-2xl font-black text-primary mb-2">
              {isAr ? "أهلاً بعودتك!" : "Welcome Back!"}
            </h2>
            <p className="text-muted-foreground text-sm leading-relaxed">
              {isAr
                ? "سعداء بعودتك مجدداً\nالف العجلة وحظك يحدد جائزتك! 🎰"
                : "Great to see you again!\nSpin the wheel and claim your prize! 🎰"}
            </p>
          </>
        )}
        <div className="mt-6 w-full bg-muted rounded-full h-1 overflow-hidden">
          <div className="h-1 bg-primary rounded-full animate-[shrink_3s_linear_forwards]" style={{ animation: "width 3s linear forwards", width: "100%" }}></div>
        </div>
        <p className="text-xs text-muted-foreground mt-2">
          {isAr ? "ستنتقل تلقائياً للعجلة..." : "Redirecting to wheel..."}
        </p>
      </div>
    </div>
  );
}